<template>
  <div>
    <v-card>
      <v-card-text class="pt-0 pb-10 mb-5">
        <v-row>
          <span class="red--text font-weight-bold">{{
            formValidator.getError("non_field_errors")
          }}</span>
          <v-col cols="12" class="py-0 px-6">
            <v-row>
              <!-- <v-col v-if="!formValues.id" md="4" class="px-3">
                <div class="mb-2">
                  <span>
                    <v-icon
                      color="grey"
                      small
                      v-text="$getIcon('mdiInformationOutline')"
                    ></v-icon>
                  </span>
                  <span class="caption font-weight-bold mb-0">
                    Client Type:
                  </span>
                </div>
                <v-btn-toggle
                  disabled
                  v-model="selectedClientType"
                  :error-messages="formValidator.getError('client_type')"
                  mandatory
                >
                  <v-btn value="b2b" text>
                    <v-icon class="mr-2" v-text="$getIcon('mdiBriefcase')">
                    </v-icon>
                    B2B
                  </v-btn>
                  <v-btn disabled value="b2c" text>
                    <v-icon class="mr-2" v-text="$getIcon('mdiAccount')">
                    </v-icon>
                    B2C
                  </v-btn>
                </v-btn-toggle>
              </v-col> -->
              <v-col cols="12" md="4">
                <div>
                  <span>
                    <v-icon
                      color="grey"
                      small
                      v-text="$getIcon('mdiAccountBoxOutline')"
                    ></v-icon>
                  </span>
                  <span class="caption font-weight-bold mb-0">
                    Client Name: <span class="red--text">*</span>
                  </span>
                </div>
                <v-text-field
                  class="pt-0"
                  v-model="formValues.name"
                  :error-messages="formValidator.getError('name')"
                  placeholder="Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <div>
                  <span>
                    <v-icon
                      color="grey"
                      small
                      v-text="$getIcon('mdiAccountBoxOutline')"
                    ></v-icon>
                  </span>
                  <span class="caption font-weight-bold mb-0">
                    Client Email: <span class="red--text">*</span>
                  </span>
                </div>
                <v-text-field
                  class="pt-0"
                  v-model="formValues.email"
                  :error-messages="formValidator.getError('email')"
                  placeholder="Email"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <div>
                  <span>
                    <v-icon
                      color="grey"
                      small
                      v-text="$getIcon('mdiFileImageOutline')"
                    ></v-icon>
                  </span>
                  <span class="caption font-weight-bold mb-0">
                    Client Logo:
                  </span>
                </div>
                <vue-image-upload
                  v-if="clientLogo.dialog"
                  v-model="formValues.logo"
                  profile
                  @close="clientLogo.dialog = false"
                  @croppedImage="uploadClientLogo"
                ></vue-image-upload>
                <div v-if="clientLogo.url" class="text-center">
                  <v-hover>
                    <v-img
                      slot-scope="{ hover }"
                      :src="clientLogo.url"
                      style="height: 80px; border-radius: 100%; width: 80px; border:2px solid #efefef;"
                    >
                      <v-expand-transition>
                        <div
                          v-if="hover"
                          class="pointer d-flex transition-fast-in-fast-out display-3 white--text"
                          @click="clientLogo.url = false"
                        >
                          <v-icon
                            size="30"
                            v-text="$getIcon('mdiClose')"
                          ></v-icon>
                        </div>
                      </v-expand-transition>
                    </v-img>
                  </v-hover>
                </div>
                <div v-else-if="formValues.logo" class="text-center">
                  <v-hover>
                    <v-img
                      slot-scope="{ hover }"
                      :src="formValues.logo"
                      style="height: 80px; width: 80px; border:2px solid #efefef;"
                    >
                      <v-expand-transition>
                        <div
                          v-if="hover"
                          class="pointer d-flex transition-fast-in-fast-out display-3 white--text"
                          @click="
                            (formValues.logo = ''), (clientLogo.dialog = false)
                          "
                        >
                          <v-icon
                            size="24"
                            v-text="$getIcon('mdiClose')"
                          ></v-icon>
                        </div>
                      </v-expand-transition>
                    </v-img>
                  </v-hover>
                </div>
                <v-responsive
                  v-else
                  style="height: 80px; width: 80px;"
                  class="pa-1 ma-1 grey lighten-3 pointer"
                  @click="clientLogo.dialog = true"
                >
                  <v-row class="" justify="center" align="center">
                    <v-col cols="12" class="pb-0 px-0 text-center">
                      <v-icon
                        color="grey"
                        size="30"
                        v-text="$getIcon('mdiUpload')"
                      ></v-icon>
                    </v-col>
                    <v-col
                      class="text-center caption grey--text py-0"
                      v-text="'Logo'"
                    ></v-col>
                  </v-row>
                </v-responsive>
              </v-col>

              <v-col cols="12" v-if="selectedClientType === 'b2b'" md="4">
                <div>
                  <span>
                    <v-icon
                      color="grey"
                      small
                      v-text="$getIcon('mdiAccountBoxOutline')"
                    ></v-icon>
                  </span>
                  <span class="caption font-weight-bold mb-0">
                    Alternate Name:
                  </span>
                </div>

                <v-text-field
                  class="pt-0"
                  v-model="formValues.alternate_name"
                  :error-messages="formValidator.getError('alternate_name')"
                  placeholder="Alternate Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" v-if="selectedClientType === 'b2b'" md="4">
                <div>
                  <span>
                    <v-icon
                      color="grey"
                      small
                      v-text="$getIcon('mdiAccountBoxOutline')"
                    ></v-icon>
                  </span>
                  <span class="caption font-weight-bold mb-0">
                    Abbreviation:
                  </span>
                </div>
                <v-text-field
                  class="pt-0"
                  v-model="formValues.abbreviation"
                  :error-messages="formValidator.getError('abbreviation')"
                  placeholder="Abbreviation"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <div>
                  <span>
                    <v-icon
                      color="grey"
                      small
                      v-text="$getIcon('mdiChartBar')"
                    ></v-icon>
                  </span>
                  <span class="caption font-weight-bold mb-0">
                    Client Values:
                  </span>
                </div>
                <v-select
                  v-model="formValues.client_value"
                  class="pt-0"
                  :error-messages="formValidator.getError('client_value')"
                  :items="clientValues"
                ></v-select>
              </v-col>
              <v-col cols="12" v-if="selectedClientType === 'b2b'" md="4">
                <div>
                  <span>
                    <v-icon
                      color="grey"
                      small
                      v-text="$getIcon('mdiAccountGroupOutline')"
                    ></v-icon>
                  </span>
                  <span class="caption font-weight-bold mb-0">
                    Client Size:
                  </span>
                </div>
                <v-select
                  class="pt-0"
                  v-model="formValues.client_size"
                  :error-messages="formValidator.getError('client_size')"
                  :items="clientSizes"
                ></v-select>
              </v-col>
              <v-col cols="12" v-if="selectedClientType === 'b2b'" md="4">
                <div>
                  <span>
                    <v-icon
                      color="grey"
                      small
                      v-text="$getIcon('mdiDomain')"
                    ></v-icon>
                  </span>
                  <span class="caption font-weight-bold mb-0">
                    Industry:<span class="red--text">*</span>
                  </span>
                </div>
                <vue-select
                  class="pt-0"
                  placeholder="Industry"
                  v-model="formValues.industry"
                  :endpoint="industryEndpoint"
                  :error-messages="formValidator.getError('industry')"
                  item-text="name"
                  item-value="id"
                ></vue-select>
              </v-col>
              <v-col cols="12" md="4">
                <div>
                  <span>
                    <v-icon
                      color="grey"
                      small
                      v-text="$getIcon('mdiWeb')"
                    ></v-icon>
                  </span>
                  <span class="caption font-weight-bold mb-0">
                    Website:
                  </span>
                </div>
                <v-text-field
                  v-model="formValues.website"
                  class="pt-0"
                  :error-messages="formValidator.getError('website')"
                  placeholder="Website"
                ></v-text-field>
                
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="formValues.reference_id"
                  class="pt-0"
                  :error-messages="formValidator.getError('reference_id')"
                  placeholder="Merojob Id"
                  type="number"
                ></v-text-field>
                <v-icon
                  color="grey"
                  small
                  v-text="$getIcon('mdiSwapHorizontal')"
                ></v-icon>
                <span class="subtitle-2 font-weight-bold mb-0">
                  Medium Direction:
                </span>
                <v-row>
                  <v-col
                    v-for="(item, index) in mediumDirectionTypes"
                    :key="index"
                    cols="5"
                    class="text-center"
                  >
                    <v-btn
                      :color="
                        formValues.source_medium_direction === item.name
                          ? 'blue darken-2'
                          : ''
                      "
                      @click="
                        (formValues.source_medium_direction = item.name),
                          fetchClientSource(item.value)
                      "
                      height="40"
                      width="60"
                    >
                      <v-icon
                        v-if="item.name === 'Inbound'"
                        :color="
                          formValues.source_medium_direction === 'Inbound'
                            ? 'white'
                            : 'blue darken-2'
                        "
                        v-text="$getIcon('mdiArrowDownBoldCircleOutline')"
                      >
                      </v-icon>
                      <v-icon
                        v-if="item.name === 'Outbound'"
                        :color="
                          formValues.source_medium_direction === 'Outbound'
                            ? 'white'
                            : 'blue darken-2'
                        "
                        v-text="$getIcon('mdiArrowUpBoldCircleOutline')"
                      >
                      </v-icon>
                    </v-btn>
                    <div class="caption font-weight-bold mt-1">
                      {{ item.name }}
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col v-if="clientSources.length" md="12" class="my-2">
                <vue-carousel
                  :key="key"
                  :show-button="clientSources.length > 8"
                >
                  <template slot="buttonsColumn">
                    <span>
                      <v-icon
                        color="grey"
                        small
                        v-text="$getIcon('mdiPhoneSettingsOutline')"
                      ></v-icon>
                    </span>
                    <span class="subtitle-2 font-weight-bold mb-0">
                      Client Source:
                    </span>
                  </template>
                  <template v-if="clientSources.length" slot="carousel">
                    <div
                      v-for="(source, index) in clientSources"
                      :key="index"
                      class="text-center pointer mx-3"
                    >
                      <v-card
                        :class="
                          `elevation-${
                            source.id === formValues.source
                              ? `3 blue darken-2`
                              : `2`
                          }`
                        "
                        class="pointer"
                        @click="$set(formValues, 'source', source.id)"
                      >
                        <v-card-text class="px-0">
                          <v-icon
                            :color="
                              source.id === formValues.source
                                ? 'white'
                                : 'blue darken-2'
                            "
                            size="25"
                          >
                            {{ $options.mediumIcons[source.icon] }}
                          </v-icon>
                        </v-card-text>
                      </v-card>
                      <div
                        class="caption font-weight-bold pointer mt-1"
                        @click="$set(formValues, 'source', source.id)"
                      >
                        {{ truncate(source.name, 9) }}
                      </div>
                    </div>
                  </template>
                </vue-carousel>
              </v-col>
              <v-col cols="12" v-if="selectedClientType === 'b2c'" md="4">
                <div>
                  <span>
                    <v-icon
                      color="grey"
                      small
                      v-text="$getIcon('mdiGenderMaleFemale')"
                    ></v-icon>
                  </span>
                  <span class="caption font-weight-bold mb-0">
                    Gender:
                  </span>
                </div>
                <v-select
                  v-model="formValues.gender"
                  class="pt-0"
                  :error-messages="formValidator.getError('gender')"
                  :items="['Male', 'Female', 'Other']"
                ></v-select>
              </v-col>
              <v-col cols="12" v-if="selectedClientType === 'b2c'" md="4">
                <div>
                  <span>
                    <v-icon
                      color="grey"
                      small
                      v-text="$getIcon('mdiAccountMultipleOutline')"
                    ></v-icon>
                  </span>
                  <span class="caption font-weight-bold mb-0">
                    Marital Status:
                  </span>
                </div>
                <v-select
                  class="pt-0"
                  v-model="formValues.marital_status"
                  :error-messages="formValidator.getError('marital_status')"
                  :items="['Married', 'Unmarried']"
                ></v-select>
              </v-col>
              <v-col cols="12" v-if="selectedClientType === 'b2c'" md="4">
                <div>
                  <span>
                    <v-icon
                      color="grey"
                      small
                      v-text="$getIcon('mdiCalendarMonthOutline')"
                    ></v-icon>
                  </span>
                  <span class="caption font-weight-bold mb-0">
                    Date of Birth:
                  </span>
                </div>
                <vue-date-picker
                  extra-info="pt-0"
                  v-model="formValues.dob"
                  prepend-inner-icon=""
                  :error-messages="formValidator.getError('dob')"
                ></vue-date-picker>
              </v-col>
              <v-col cols="12" v-if="selectedClientType === 'b2c'" md="4">
                <div>
                  <span>
                    <v-icon
                      color="grey"
                      small
                      v-text="$getIcon('mdiMapMarkerOutline')"
                    ></v-icon>
                  </span>
                  <span class="caption font-weight-bold mb-0">
                    Permanent Address:
                  </span>
                </div>
                <v-textarea
                  v-model="formValues.permanent_address"
                  :error-messages="formValidator.getError('permanent_address')"
                  placeholder="Permanent Address"
                  rows="3"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" class="px-2">
            <v-row class="grey lighten-3 px-5">
              <v-col cols="12" md="4">
                <div>
                  <span>
                    <v-icon
                      color="grey"
                      small
                      v-text="$getIcon('mdiFlagOutline')"
                    ></v-icon>
                  </span>
                  <span class="caption font-weight-bold mb-0">
                    Country:
                  </span>
                </div>
                <v-text-field
                  v-model="formValues.address.country"
                  class="pt-0"
                  :error-messages="formValidator.getError('location.country')"
                  placeholder="Country"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <div>
                  <span>
                    <v-icon
                      color="grey"
                      small
                      v-text="$getIcon('mdiMapMarkerOutline')"
                    ></v-icon>
                  </span>
                  <span class="caption font-weight-bold mb-0">
                    State:
                  </span>
                </div>
                <v-text-field
                  class="pt-0"
                  v-model="formValues.address.state"
                  :error-messages="formValidator.getError('location.state')"
                  placeholder="State"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <div>
                  <span>
                    <v-icon
                      color="grey"
                      small
                      v-text="$getIcon('mdiMapMarkerOutline')"
                    ></v-icon>
                  </span>
                  <span class="caption font-weight-bold mb-0">
                    District:
                  </span>
                </div>
                <v-text-field
                  class="pt-0"
                  v-model="formValues.address.district"
                  :error-messages="formValidator.getError('location.district')"
                  placeholder="District"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <div>
                  <span>
                    <v-icon
                      color="grey"
                      small
                      v-text="$getIcon('mdiMapMarkerOutline')"
                    ></v-icon>
                  </span>
                  <span class="caption font-weight-bold mb-0">
                    City:
                  </span>
                </div>
                <v-text-field
                  class="pt-0"
                  v-model="formValues.address.city"
                  :error-messages="formValidator.getError('location.city')"
                  placeholder="City"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <div>
                  <span>
                    <v-icon
                      color="grey"
                      small
                      v-text="$getIcon('mdiMapMarkerOutline')"
                    ></v-icon>
                  </span>
                  <span class="caption font-weight-bold mb-0">
                    Street Address: <span class="red--text">*</span>
                  </span>
                </div>
                <v-textarea
                  class="pt-0"
                  v-model="formValues.address.address"
                  :error-messages="formValidator.getError('address.address')"
                  placeholder="Current Address"
                  rows="1"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="px-7">
            <div>
              <span>
                <v-icon
                  color="grey"
                  small
                  v-text="$getIcon('mdiInformationOutline')"
                ></v-icon>
              </span>
              <span class="caption font-weight-bold mb-0">
                About:
              </span>
            </div>
            <v-textarea
              v-model="formValues.about"
              :error-messages="formValidator.getError('about')"
              placeholder="About"
              rows="2"
            ></v-textarea>
          </v-col>
          <v-col cols="12" class="px-2 py-0">
            <v-row class="px-5 grey lighten-3">
              <v-col
                v-if="selectedClientType === 'b2b'"
                cols="12"
                md="6"
                class="pt-0"
              >
                <v-row align="center">
                  <v-col cols="8" md="4" class="py-0 font-weight-bold"
                    >Public Client</v-col
                  ><v-col cols="4" md="8" class="py-0">
                    <v-switch v-model="formValues.is_public" color="green">
                    </v-switch>
                  </v-col>
                  <v-col cols="12" class="pt-0 small-font">
                    Toggle the switch to save the information on whether the
                    client is public or not.
                  </v-col>
                </v-row>
              </v-col>
              <v-col md="6" class="pt-0">
                <v-row align="center">
                  <v-col cols="8" md="4" class="py-0 font-weight-bold"
                    >Blocked Client</v-col
                  ><v-col cols="4" md="8" class="py-0">
                    <v-switch v-model="formValues.is_blocked" color="red">
                    </v-switch>
                  </v-col>
                  <v-col cols="12" class="pt-0 small-font">
                    Toggle the switch to save the information on whether the
                    client is blocked or not.
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-footer class="white pt-0" fixed height="60">
      <v-row>
        <v-col class="text-right" md="12">
          <v-btn @click="$emit('close')" text class="grey--text">
            Cancel
          </v-btn>
          <v-btn
            v-if="!formValues.id"
            color="primary"
            outlined
            @click="addAnother()"
            :disabled="loading"
          >
            Save & Add Another
          </v-btn>
          <v-btn
            :disabled="Object.keys(formValidator.errors).length > 0 || loading"
            class="primary"
            type="submit"
            @click="getActionMethod()"
            :loading="loading"
          >
            Save
          </v-btn>
        </v-col>
      </v-row>
    </v-footer>
  </div>
</template>
<script>
import { FormValidator } from "rhr-core-shell";
import { isEqual, extractDifference, deepCopy } from "@/utils/common";
import VueCarousel from "@/components/common/layout_utils/VueCarousel";
import mediumIcons from "@/utils/mediumIcons.js";

export default {
  components: { VueCarousel },
  mediumIcons,
  isEqual,
  extractDifference,
  deepCopy,
  props: {
    actionData: {
      type: Object,
      required: false,
      default() {
        return {
          // common
          name: "",
          client_value: "Mid",
          about: "",
          website: "",
          email: "",
          is_blocked: false,
          logo: "",
          cover_image: "",
          reference_id: "",
          // b2b
          b2b: {
            is_public: false,
            alternate_name: "",
            abbreviation: "",
            industry: "",
            client_size: "1 - 10 employees",
            address: {
              address: "",
              city: "",
              district: "",
              state: "",
              country: ""
            }
          },
          // b2c
          b2c: {
            dob: "",
            nationality: "",
            gender: "",
            marital_status: "",
            current_address: "",
            permanent_address: "",
            is_disabled: false
          }
        };
      }
    },
    clientType: {
      type: String,
      required: true
    }
  },
  data() {
    let initialFormValue = {
      address: {
        address: "",
        city: "",
        district: "",
        state: "",
        country: ""
      },
      source_medium_direction: "Inbound",
      client_size: "1 - 10 employees",
      client_value: "Mid",
      ...this.actionData,
      ...this.actionData.b2b,
      ...this.actionData.b2c,
      organization: this.$store.state.shell.currentOrganizationId,
      source:
        (this.actionData &&
          this.actionData.source &&
          this.actionData.source.id) ||
        ""
    };
    return {
      sourceChoices: ["Inbound", "Outbound"],
      formValidator: new FormValidator(),
      saveAndAddAnother: false,
      industryEndpoint: `/api/v1/crm/industry/choices/?fields=name,id&?organization__slug=${this.$store.state.shell.currentOrganizationId}`,
      clientValues: ["High", "Mid", "Low"],
      clientSizes: [
        "1 - 10 employees",
        "10 - 50 employees",
        "50 - 100 employees",
        "100 - 200 employees",
        "200 - 500 employees",
        "500 - 1000 employees",
        "1000+ employees",
        "Confidential"
      ],
      mediumDirectionTypes: [
        {
          name: "Inbound",
          value: "is_inbound",
          icon: "mdiArrowDownBoldCircleOutline"
        },
        {
          name: "Outbound",
          value: "is_outbound",
          icon: "mdiArrowUpBoldCircleOutline"
        }
      ],
      clientSources: [],
      clientTypes: [
        { name: "B2B", icon: this.$getIcon("mdiBriefcase"), value: "b2b" },
        { name: "B2C", icon: this.$getIcon("mdiAccount"), value: "b2c" }
      ],
      selectedClientType: this.clientType,
      clientAPI: {
        b2b: "/api/v1/crm/b2b-clients/",
        b2c: "/api/v1/crm/b2c-clients/"
      },
      formValues: initialFormValue,
      copiedValue: this.$options.deepCopy(initialFormValue),
      clientLogo: {
        // for b2c this is profile picture
        dialog: false,
        name: "",
        url: ""
      },
      clientCover: {
        dialog: false,
        name: "",
        url: ""
      },
      key: 0,
      contacts: [
        {
          number_type: "Mobile",
          number: ""
        }
      ],
      loading: false
    };
  },
  computed: {
    clientTypeAPI() {
      return this.clientAPI[this.selectedClientType];
    }
  },
  watch: {
    formValues: {
      handler() {
        this.formValidator.setError({});
      },
      deep: true
    }
    // actionData() {
    //   this.formValues = { ...this.actionData, ...this.actionData.b2b, ...this.actionData.b2c }
    // }
  },
  created() {
    this.fetchClientSource("is_inbound");
  },
  methods: {
    fetchClientSource(type) {
      const clientSourceAPI = `/api/v1/crm/client-source/choices/?fields=id,name,icon&${type}=true`;
      this.$axios.$get(clientSourceAPI).then(response => {
        this.clientSources = response;
        this.key += 1;
      });
    },
    truncate(text, length, suffix) {
      if (!text) return "";
      let truncatedText = "";
      suffix = suffix || "...";
      if (text.length > length) {
        truncatedText = text.substring(0, length) + suffix;
      } else {
        truncatedText = text.substring(0, length);
      }
      return truncatedText;
    },
    getActionMethod() {
      this.loading = true;
      if (this.formValues.id) return this.updateClient();
      return this.createClient();
    },
    addAnother() {
      (this.saveAndAddAnother = true), this.getActionMethod();
    },
    async createClient() {
      const clientAPI = this.clientTypeAPI;
      this.loading = true;
      this.$axios
        .$post(clientAPI, this.formValues)
        .then(() => {
          this.loading = false;
          if (this.contacts.length > 0 && Boolean(this.contacts[0].number)) {
            this.postClientContacts();
          } else {
            this.$store.dispatch("shell/showSnackbar", {
              text: `Successfully created client!`,
              color: "green"
            });
            if (this.saveAndAddAnother) {
              this.clearForm();
              this.saveAndAddAnother = false;
              this.$emit("clientFormResponse", "created");
            } else {
              this.$emit("close");
              this.$emit("clientFormResponse", "created");
            }
          }
        })
        .catch(error => {
          this.loading = false;
          this.saveAndAddAnother = false;
          this.formValidator.setError(error.response.data);
        });
    },
    async updateClient() {
      const clientAPI = this.clientTypeAPI + this.formValues.slug + "/";
      let newFormValues = this.$options.extractDifference(
        this.copiedValue,
        this.formValues
      );
      this.$axios
        .$patch(clientAPI, newFormValues)
        .then(response => {
          this.loading = false;
          this.$store.dispatch("shell/showSnackbar", {
            text: `Successfully updated client!`,
            color: "green"
          });
          this.$emit("clientFormResponse", response);
          this.$emit("close");
        })
        .catch(error => {
          this.loading = false;
          this.formValidator.setError(error.response.data);
        });
    },
    uploadClientLogo(image) {
      this.clientLogo.name = image.name;
      this.clientLogo.url = URL.createObjectURL(image);
      this.clientLogo.dialog = false;
    },
    clearForm() {
      this.formValues = {
        client_size: "1 - 10 employees",
        client_value: "Mid",
        logo: null,
        name: "",
        alternate_name: "",
        abbreviation: "",
        industry: "",
        website: "",
        about: "",
        is_public: false,
        is_blocked: false,
        address: {
          address: "",
          state: "",
          city: "",
          district: "",
          country: ""
        },
        organization: this.$store.state.shell.currentOrganizationId
      };
    },
    uploadClientCover(image) {
      this.clientCover.name = image.name;
      this.clientCover.url = URL.createObjectURL(image);
      this.clientCover.dialog = false;
    },
    appendContact() {
      this.contacts.push({ number_type: "Mobile", number: "" });
    },
    removeContact(index) {
      this.contacts.splice(index, 1);
    },
    postClientContacts() {
      this.$emit("clientFormResponse", "created");
    }
  }
};
</script>
<style scoped>
.small-font {
  font-size: 10px;
}
</style>
